<template>
  <div class="base-box">
      <van-field
        class="input-item"
        v-model="params.mobile"
        label="手机号"
        required
        placeholder="请输入您的手机号码"
      ></van-field>
      <van-field
        class="input-item"
        v-model="params.code"
        label="验证码"
        required
        clearable
        placeholder="请输入短信验证码"
      >
        <van-button
          :disabled="isDisabled"
          slot="button"
          size="small"
          type="primary"
          @click="getCode"
        >
        <template v-if="!isSpend">获取验证码</template>
        <template v-else>( {{time}} )</template>
        </van-button>
      </van-field>
    <van-field
      class="input-item"
      v-model="params.name"
      label="真实姓名"
      required
      placeholder="请输入您的真实姓名"
    ></van-field>
    <van-button class="successedBtn" type="primary" size="large" @click="next">完成</van-button>
    <van-checkbox
      class="rule-box"
      checked-color="#228ccd"
      v-model="checked"
      icon-size="16px"
    >
      我已阅读
      <span @click.stop="goHerf">《入会须知》</span>
    </van-checkbox>
  </div>
</template>

<script>
import { Field, Button, Checkbox, Toast, Popup, Cell, CellGroup ,Picker,Divider } from "vant";
import { fastRegisterMember,getRegisterCode,verifyRegisterCode,checkMobile} from "@/api/login";
import { getUser } from "@/api/dictionary";
import { mapState, mapGetters, mapActions, mapMutations } from "vuex";
import { setSessionStore } from "@/utils/sessionStorage";
export default {
  data() {
    return {
      time: 60,
      isSpend: false,
      isDisabled: false,
      params: {
        mobile: "",
        code: "",
        name: "",
      },
      checked: false,
      isShowPW: true,
      isShowPW2: true,
      isDisabled: false,
      beginClientX: 0 /*距离屏幕左端距离*/,
      mouseMoveStata: false /*触发拖动状态  判断*/,
      maxwidth: "" /*拖动最大宽度，依据滑块宽度算出来的*/,
      confirmWords: "请按住滑块，拖到最右边" /*滑块文字*/,
      confirmSuccess: false /*验证成功判断*/,
      selectModel: false,
      memberName: "",
      key: "",
      columns: [],
      value:0
    };
  },
  components: {
    [Field.name]: Field,
    [Button.name]: Button,
    [Checkbox.name]: Checkbox,
    [Popup.name]: Popup,
    [Cell.name]: Cell,
    [Picker.name]: Picker,
    [CellGroup.name]:CellGroup,
    [Divider.name]:Divider
  },
  computed: {
    ...mapState(["memberTypeList"]),
  },
  methods: {
    ...mapActions(["securityCheck"]),
    ...mapMutations(["setMemberInfo"]),
    register() {
      let params ={
        mobile:this.params.mobile,
        code:this.params.code,
      }
      verifyRegisterCode(params).then(res => {
          if (res.success) {
            let params = this.params;
                params.password = this.params.mobile;
                params.password2 = this.params.mobile;
                params.memberCategory=1;
                params.memberType=9;
            fastRegisterMember(params).then((res) => {
              if (res.success) {
                  this.submit();
              } else {
                if (res.messageCode == "110001") {
                  Toast.fail("手机号码已经注册");
                  return;
                }
                if (res.messageCode == "110002") {
                  Toast.fail("手机号码已经注册");
                  return;
                }
                Toast.fail("注册失败!");
              }
            });
          }else {
          Toast("验证码不正确！");
        }
      });
    },
    submit() {
      var params = {
        username: this.params.mobile,
        password: this.params.mobile,
        memberCategory: 2,
        grant_type: "password",
        scope: "server",
        client_id: "mms_meeting",
        client_secret: 123456,
      };
      this.securityCheck(params)
        .then((res) => {
          this.getUserInfo()
            .then((res) => {
              this.$router.push({ name: "MeetingList" });
            })
            .catch(() => {
               Toast.fail("用户信息获取失败");
            });
        })
        .catch((res) => {
           Toast.fail("登录失败");
        });
    },
    getUserInfo() {
      return new Promise((resolve) => {
        getUser().then((res) => {
          if (res.success) {
            this.userInfo = res.result;
            this.setMemberInfo(res.result);
            setSessionStore("memberId", res.result.id);
            resolve();
          } else {
            Toast("用户信息获取失败");
          }
        });
      });
    },
    goHerf() {
      this.$router.push({ path: "/rule" });
    },
    async next() {
      if (!this.params.mobile) {
        Toast("请输入手机号！");
        return;
      }
      if (!this.params.code) {
        Toast("请输入验证码！");
        return;
      }
      if (!this.params.name) {
        Toast("请输入真实姓名！");
        return;
      }
      if (!this.checked) {
        Toast("请阅读入会须知！");
        return;
      }
      this.register();
    },
    async getCode() {
      let mobile = this.params.mobile;
      if (this.isSpend|| this.params.mobile === 0) {
        return;
      }
      if (!this.$regexp.mobile(mobile)) {
        Toast("请输入正确的手机号");
        return false;
      }
      await this.checkMobiles(this.params.mobile);
      getRegisterCode({ mobile }).then((res) => {
        if (res.success) {
          this.isSpend = true;
          this.time = 60;
          this.count();
        }
      });
    },
    checkMobiles(mobile) {
      let params = {
        mobile
      };
      return new Promise((resolve, reject) => {
        checkMobile(params)
          .then(res => {
            if (!res.result && res.success) {
              resolve();
            } else {
              Toast("该手机号码已经注册过！");
            }
          })
          .catch(() => {
            Toast("该手机号码已经注册过！");
          });
      });
    },
    count() {
      --this.time;
      if (this.time > 0) {
        setTimeout(() => {
          this.count();
        }, 1000);
      } else {
        this.isSpend = false;
      }
    },
  },
  mounted() {
    this.params.memberCategory = this.$route.query.memberCategory;
  },
};
</script>

<style lang="less" scoped>
  .van-cell--required::before{ left:0!important}
  .input-item {
    padding-right:0;
    padding-top: 0;
    padding-bottom: 12px;
    i {
      color: #aaa;
    }
    & + .input-item {
      margin-top:20px;
    }
  }
  /deep/.van-field__label{ width:2rem}
  .successedBtn {
    margin: 30px 0 25px 0 !important;
  }
  .rule-box{justify-content: center; margin-bottom: 20px;}
.type_box{ overflow: hidden; border-bottom: #dfdfdf solid 1px; margin-bottom: 30px; margin-top: -10px;}
.type_box p{ float: left; font-size: 15px; height: 50px; line-height: 50px; color: #333;}
</style>
